module.exports = __webpack_public_path__ + "img/B6_Farming_Pools.95ae9219.png";